import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box
} from "@chakra-ui/react";

export const ModalBox = ({
  title,
  description,
  isOpen,
  onClose,
  isFooter = false,
  cancelButtonText = "Cancel",
  confirmButtonText = "Confirm",
  onConfirm = () => { },
  onCancel = () => { },
  isDeleteButton = false,
  confirmButtonType = false,
  size = "md",
  styleProps,
  loadingText = "",
  isWorking = false,
  isNoPadding = false,
  loading,
  isHideDivider = false,
  isConfirmButtonDisabled = false
}) => {
  const content = () => (
    <>
      <ModalBody padding="1rem 1.5rem" paddingTop={`${isNoPadding ? 0 : "1rem"}`} overflowY="scroll">{description}</ModalBody>
      {isFooter && (
        <ModalFooter borderTop="1px solid #eee" >
          <Button
            colorScheme="blue"
            fontWeight="600"
            variant="outline"
            onClick={onCancel}
            marginRight="20px"
            disabled={isWorking}
          >
            {cancelButtonText}
          </Button>
          {confirmButtonType ? (
            <Button
              colorScheme="blue"
              background={isDeleteButton ? "rgba(209, 62, 42, 1)" : "#1b6ec2"}
              fontWeight="600"
              _hover={{
                background: isDeleteButton
                  ? "rgba(209, 62, 42, 0.9)"
                  : "#1b6ec2",
              }}
              _focus={{
                background: isDeleteButton
                  ? "rgba(209, 62, 42, 0.9)"
                  : "#1b6ec2",
              }}
              _active={{
                background: isDeleteButton
                  ? "rgba(209, 62, 42, 0.9)"
                  : "#1b6ec2",
              }}
              type="submit"
              loadingText={loadingText?? confirmButtonText}
              isLoading={isWorking}
              disabled={isConfirmButtonDisabled}
            >
              {confirmButtonText}
            </Button>
          ) : (
            <Button
              colorScheme="blue"
              background={isDeleteButton ? "rgba(209, 62, 42, 1)" : "#1b6ec2"}
              fontWeight="600"
              _hover={{
                background: isDeleteButton
                  ? "rgba(209, 62, 42, 0.9)"
                  : "#1b6ec2",
              }}
              _focus={{
                background: isDeleteButton
                  ? "rgba(209, 62, 42, 0.9)"
                  : "#1b6ec2",
              }}
              _active={{
                background: isDeleteButton
                  ? "rgba(209, 62, 42, 0.9)"
                  : "#1b6ec2",
              }}
              onClick={onConfirm}
              loadingText={loadingText?? confirmButtonText}
              isLoading={isWorking}
              disabled={isConfirmButtonDisabled}
            >
              {confirmButtonText}
            </Button>
          )}
        </ModalFooter>
      )}
    </>
  );
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      closeOnEsc={!loading}
      closeOnOverlayClick={!loading}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent {...styleProps}>
        <ModalHeader sx={{border: isHideDivider ? `1px solid #eee` : "none", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <Box as="span" maxW="90%" isTruncated>{title}</Box>
          {loading ? <></> : <ModalCloseButton top="17px" />}
        </ModalHeader>
        {confirmButtonType ? (
          <Box
            as="form"
            onSubmit={(e) => {
              e.preventDefault();
              onConfirm(e);
            }}
            sx={{
              display:"flex",
              height: "100%",
              flexDirection: "column",
              flex: "1 1 0%",
              overflow: "hidden",
            }}
          >
            {content()}
          </Box>
        ) : (
          content()
        )}
      </ModalContent>
    </Modal>
  );
};
